export class QuestionPreviewModalServices {

  static openModal(questions, currentQuestionId){
    const previewModal = document.querySelector('ml-questions-preview-modal');
    if (previewModal) previewModal.open(questions, +currentQuestionId);
  }
}
